export default __webpack_public_path__ + "static/media/coffeeorange.0052a344.png";